import { INFLUENCER_SIGNUP_CATEGORIES } from '../../../constants/influencerOptions';
import { countWords, PROFILE_BIO_MIN_WORDS } from '../../settings/profileFormHelpers';
import { validateFollowSuggestions } from '../shared/followSuggestionGroups';

export const STEP_IDS = {
  BASICS: 'basics',
  PROFILE: 'profile',
  ABOUT: 'about',
  CONTENT: 'content',
  CATEGORIES: 'categories',
  FOLLOW: 'follow',
};

const BASE_STEPS = [
  {
    id: STEP_IDS.BASICS,
    question: 'Let brands know who you are.',
    helperText: 'Add your name so brands can recognize you.',
    inputType: 'basics',
    required: true,
    validate: (formData) => {
      if (!formData.fullName?.trim()) return 'Full name is required';
      return null;
    },
  },
  {
    id: STEP_IDS.PROFILE,
    question: 'Set a profile picture',
    helperText: 'Add a photo so brands can recognize you.',
    inputType: 'creatorProfile',
    required: true,
    validate: (formData) => {
      if (!formData.profilePictureUrl?.trim()) return 'Profile photo is required';
      return null;
    },
  },
  {
    id: STEP_IDS.ABOUT,
    question: 'How should brands see you?',
    helperText: 'Add at least 5 words so brands know what you create.',
    inputType: 'about',
    required: true,
    validate: (formData, options = {}) => {
      if (!formData.about?.trim()) return 'About is required';
      if (!options.skipWordMinimum && countWords(formData.about) < PROFILE_BIO_MIN_WORDS) {
        return 'Use at least 5 words.';
      }
      return null;
    },
  },
  {
    id: STEP_IDS.CONTENT,
    question: 'Where can brands find you?',
    helperText: 'Add the profiles you want to show on Millet. You can update these anytime.',
    inputType: 'contentProfile',
    required: false,
    validate: () => null,
  },
  {
    id: STEP_IDS.CATEGORIES,
    question: 'What categories best describe your content?',
    helperText: 'Choose up to 5 categories so brands can match you to the right campaigns.',
    inputType: 'contentCategories',
    categoryOptions: INFLUENCER_SIGNUP_CATEGORIES,
    maxSelect: 5,
    required: true,
    validate: (formData) => (formData.contentCategories.length === 0 ? 'Select at least one category' : null),
  },
  {
    id: STEP_IDS.FOLLOW,
    question: 'Follow brands to start',
    helperText: 'Select 1 or more, or skip this step.',
    inputType: 'followSuggestions',
    actionLabel: 'Follow',
    required: false,
    validate: validateFollowSuggestions,
  },
];

export function buildSteps() {
  return BASE_STEPS;
}
